// import Carousel from "react-bootstrap/Carousel";
import Carousel from "react-multi-carousel";

import {
  CAROUSEL_REMOVE_ARRAOW_ON_DEVICE,
  LOGIN_BANNER_CAROUSEL,
} from "../../utils/Constants";
import pandit from "../../assets/pandit-carousel.svg";
import templeSingle from "../../assets/temple-single-carousel.svg";
import templeWide from "../../assets/temple-wide-carousel.svg";
import { Box, Typography } from "@mui/material";
import { LOCALIZATION } from "../../utils/localization";
import { t } from "i18next";
import { LazyLoadImage } from "react-lazy-load-image-component";

function CarouselComponent() {
  return (
    <Box>
      <Carousel
        responsive={LOGIN_BANNER_CAROUSEL}
        swipeable={true}
        draggable={true}
        showDots={true}
        keyBoardControl={true}
        removeArrowOnDeviceType={CAROUSEL_REMOVE_ARRAOW_ON_DEVICE}
        autoPlay={true}
        autoPlaySpeed={4000}
        infinite={true}
        className="mainCarousel"
      >
        <Box className="carouselInnerItem">
          <LazyLoadImage
            src={templeSingle}
            alt="carouselInnerItem puja"
            effect="blur"
            wrapperProps={{
              // If you need to, you can tweak the effect transition using the wrapper style.
              style: { transitionDelay: "1s" },
            }}
          />
          <Typography>
            {t(
              LOCALIZATION.Experience_divine_convenience_Book_temple_pujas_anytime_anywhere_with_Temple_Dekho
            )}
          </Typography>
        </Box>
        <Box className="carouselInnerItem">
          <LazyLoadImage
            src={templeWide}
            alt="carouselInnerItem temple"
            effect="blur"
            wrapperProps={{
              // If you need to, you can tweak the effect transition using the wrapper style.
              style: { transitionDelay: "1s" },
            }}
          />
          <Typography>
            {t(
              LOCALIZATION.Elevate_your_spiritual_journey_with_seamless_temple_puja_booking_through_Temple_Dekho
            )}
          </Typography>
        </Box>
        <Box className="carouselInnerItem">
          <LazyLoadImage
            src={pandit}
            alt="carouselInnerItem pandit"
            effect="blur"
            wrapperProps={{
              // If you need to, you can tweak the effect transition using the wrapper style.
              style: { transitionDelay: "1s" },
            }}
          />
          <Typography>
            {t(
              LOCALIZATION.Elevate_your_home_pujas_with_ease_Book_a_pandit_for_hassle_free_house_pujas_at_your_fingertips
            )}
          </Typography>
        </Box>
      </Carousel>
    </Box>
  );
}

export default CarouselComponent;
